export type InventoryEntityRef =
	| { readonly type: 'device'; readonly id: string }
	| { readonly type: 'group'; readonly id: string }
	| { readonly type: 'space'; readonly id: string };

export type InventorySelectionState = InventoryEntityRef['type'] | 'none' | 'mixed';

export function classifySelections(selections: readonly InventoryEntityRef[]): InventorySelectionState {
	if (selections.length === 0) {
		return 'none';
	}
	const firstType = selections[0].type;
	const allSameType = selections.every((selection) => selection.type === firstType);
	return allSameType ? firstType : 'mixed';
}
